import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum AccountStatus {
	Unverified = 0,
	New = 1,
	Accepted = 2,
	Rejected = 3,
	Blocked = 4,
	Inquiring = 5,
	OnHold = 6
}


export namespace AccountStatus {

	export function getTitle(type: AccountStatus): string {
		return Object.keys(AccountStatus).find(key => AccountStatus[key] === type);
	}

}


@Pipe({
	name: 'accountStatusText',
	standalone: true
})
export class AccountStatusTextPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	accountStatus = AccountStatus;
	translatedText: string;

	transform(value: AccountStatus): any {
		this.getTranslate(
			this.accountStatus.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.ACCOUNT_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}

